export default __webpack_public_path__ + "static/BasisGrotesque-Regular-ae382c01a3fe63b6115596c59727a957.woff";